import storyValidator from './sync/story'
import { createSyncValidator } from 'app/validators/base'

const syncValidate = createSyncValidator({
  field: 'story',
  validator: storyValidator,
})

export { syncValidate }
